import { ContractTerms } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { inputValidationRuleMap } from 'src/components/Input/inputValidationRuleMap';
import { InputValidationRuleType } from 'src/constants';
import { defaultContractTermsErrorMessage, defaultIsContractTermInputValid } from 'src/constants/rateCards';

export const revenueValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.GreaterEqual0LessEqual1,
    InputValidationRuleType.Max8Char
];

export const asdRatchetsInputDefinitionsRules: InputValidationRuleType[] = [InputValidationRuleType.Required];

export const multiplierInputValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.GreaterEqual0LessEqual1,
    InputValidationRuleType.Max8Char
];

export const thirdPartyDeductionCapsInputValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.GreaterEqual0LessEqual1,
    InputValidationRuleType.Max8Char
];

export const thresholdInputValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.GreaterEqual1
];

export const ratesReducedInputValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.FractionGreater0LessEqual1
];

export const studentTrueUpInputValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.Max8Char,
    InputValidationRuleType.Greater0LessEqual1
];

export const prsDeductionCapInputValidationRules: InputValidationRuleType[] = [
    InputValidationRuleType.Required,
    InputValidationRuleType.Max8Char,
    InputValidationRuleType.Greater0LessEqual1
];

export const contractTermsValidationRules: Record<string, Record<string, InputValidationRuleType[]>> = {
    revenue: {
        revSharePercent: revenueValidationRules,
        vpirVendorParticipation1: revenueValidationRules,
        vpirVendorParticipation2: revenueValidationRules,
        vpirVendorParticipation3: revenueValidationRules
    },
    rateMultipliers: {
        annual: multiplierInputValidationRules,
        asdExtendedTrial2m: multiplierInputValidationRules,
        asdExtendedTrial3m: multiplierInputValidationRules,
        daily: multiplierInputValidationRules,
        extendedTrial2m: multiplierInputValidationRules,
        extendedTrial3m: multiplierInputValidationRules,
        extendedTrial4m: multiplierInputValidationRules,
        extendedTrial5m: multiplierInputValidationRules,
        extendedTrial6m: multiplierInputValidationRules,
        priceDrop3m: multiplierInputValidationRules,
        priceDrop4m: multiplierInputValidationRules,
        priceDrop6m: multiplierInputValidationRules,
        weekly: multiplierInputValidationRules,
        winback: multiplierInputValidationRules
    },
    asdRatchets: {
        inputDefinitions: asdRatchetsInputDefinitionsRules
    },
    thirdPartyDeductionCaps: {
        globalDeductionCap: thirdPartyDeductionCapsInputValidationRules,
        appStore: thirdPartyDeductionCapsInputValidationRules,
        carrierBilling: thirdPartyDeductionCapsInputValidationRules
    },
    subscriberVolumeDiscount: {
        threshold: thresholdInputValidationRules,
        ratesReducedByFraction: ratesReducedInputValidationRules
    },
    additionalSettings: {
        studentTrueUpThresholdValue: studentTrueUpInputValidationRules
    },
    prsDeductionCap: {
        value: prsDeductionCapInputValidationRules
    }
};

const validField = (
    value: number | string | undefined,
    validationRuleArr: InputValidationRuleType[],
    isOptional: boolean
): [boolean, string] => {
    if (value === undefined) return [isOptional, ''];
    for (const rule of validationRuleArr) {
        if (!inputValidationRuleMap.get(rule)?.method(typeof value === 'number' ? value.toString() : value)) {
            const errMsg = inputValidationRuleMap.get(rule)?.errorMessage ?? '';
            return [false, errMsg];
        }
    }
    return [true, ''];
};

export const validateContractTerm = (
    contractTerm: ContractTerms | undefined,
    optionalSection: string[]
): [Record<string, boolean>, Record<string, Record<string, string>>] => {
    const contractTermInputValid: Record<string, boolean> = { ...defaultIsContractTermInputValid };
    const errMsgs: Record<string, Record<string, string>> = { ...defaultContractTermsErrorMessage };

    if (contractTerm !== undefined) {
        for (const element in contractTerm) {
            if (contractTermsValidationRules[element] !== undefined) {
                let isElementValid = true;
                const errorMessages: Record<string, string> = errMsgs[element];

                for (const elementKey in (contractTerm as any)[element]) {
                    const elementObj = (contractTerm as any)[element];
                    const validationRuleObj = contractTermsValidationRules[element];
                    if (
                        Object.prototype.hasOwnProperty.call(elementObj, elementKey) &&
                        validationRuleObj[elementKey] !== undefined
                    ) {
                        const value =
                            elementKey === 'inputDefinitions'
                                ? (elementObj as any)[elementKey]['description']
                                : (elementObj as any)[elementKey];
                        const [isValid, errMsg] = validField(
                            value,
                            validationRuleObj[elementKey],
                            optionalSection.includes(element) || optionalSection.includes(elementKey)
                        );
                        isElementValid &&= isValid;
                        errorMessages[elementKey] = errMsg;
                    }
                }

                contractTermInputValid[element] = isElementValid;
            }
        }
    }

    return [contractTermInputValid, errMsgs];
};
